import type {
  ApiResponse,
  ApiResponseEnvelope,
  PaginatedResponse,
} from '@/shared/api/types/api-response'
import type {
  ITicketDetail,
  ITicketListItem,
  SetTicketTourFeaturesPayload,
  TicketListParams,
  TicketListResponse,
} from '@/shared/api/types/ticket-types'
import { GW } from '@/shared/api/endpoints'
import { unwrapApiEnvelope } from '@/shared/api/utils/unwrapapi'
import { request } from '@/shared/libs/request'

const TICKETS_PATH = 'tickets'

export async function getTickets(params: TicketListParams): Promise<TicketListResponse> {
  const response = await request.get<ApiResponseEnvelope<PaginatedResponse<ITicketListItem>>>(
    GW.packaging(TICKETS_PATH),
    {
      params: {
        current: params.current,
        pageSize: params.pageSize,
        ...(params.tenantId ? { tenant_id: params.tenantId } : {}),
        ...(params.ticketType ? { ticket_type: params.ticketType } : {}),
        ...(params.status ? { status: params.status } : {}),
        ...(params.keyword ? { keyword: params.keyword } : {}),
      },
    },
  )
  const data = unwrapApiEnvelope(response.data)
  return {
    data: {
      data: data.data,
      total: data.total,
      current: data.current,
      pageSize: data.pageSize,
    },
  }
}

export async function getTicketById(id: string): Promise<ApiResponse<ITicketDetail>> {
  const response = await request.get<ApiResponseEnvelope<ITicketDetail>>(
    GW.packaging(`${TICKETS_PATH}/${id}`),
  )
  return { data: unwrapApiEnvelope(response.data) }
}

export async function setTicketTourFeatures(
  ticketId: string,
  tourId: string,
  payload: SetTicketTourFeaturesPayload,
): Promise<ApiResponse<ITicketDetail>> {
  const response = await request.put<ApiResponseEnvelope<ITicketDetail>>(
    GW.packaging(`${TICKETS_PATH}/${ticketId}/tours/${tourId}/features`),
    payload,
  )
  return { data: unwrapApiEnvelope(response.data), message: 'Ticket tour features updated' }
}
